// Brand config (white-label) — đọc HOÀN TOÀN từ runtime config /config.js (window.__ENV__),
// mount volume theo từng deployment. Ảnh logo/favicon cũng mount file + trỏ URL trong config.js.
// KHÔNG gọi BE. Thiếu giá trị -> fallback default HVS / logo mặc định.

const RT = () => (typeof window !== 'undefined' && window.__ENV__) || {};

export interface BrandConfig {
  app_name: string;
  copyright: string;
  primary_color: string;
  has_logo: boolean;
  has_favicon: boolean;
}

/** Mặc định = HVS (khi config.js để trống). */
export const BRAND_DEFAULTS = {
  app_name: 'HVS GATE',
  copyright: '2024 GATE-HUONGVIETSINH',
  primary_color: '#E41E26',
};

export const getBrand = (): BrandConfig => {
  const rt = RT();
  return {
    app_name: rt.APP_NAME || BRAND_DEFAULTS.app_name,
    copyright: rt.COPYRIGHT || BRAND_DEFAULTS.copyright,
    primary_color: rt.PRIMARY_COLOR || BRAND_DEFAULTS.primary_color,
    has_logo: !!rt.LOGO_URL,
    has_favicon: !!rt.FAVICON_URL,
  };
};

/** URL logo/favicon = file mount (trỏ trong config.js). Rỗng -> dùng logo/favicon mặc định. */
export const brandLogoUrl = (): string => RT().LOGO_URL || '';
export const brandFaviconUrl = (): string => RT().FAVICON_URL || '';

/** Áp brand vào document (title + favicon). Gọi 1 lần lúc bootstrap (đồng bộ, không fetch). */
export function applyBrand(): void {
  const b = getBrand();
  document.title = b.app_name;
  if (b.has_favicon) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = brandFaviconUrl();
  }
}
